import type { TranslationKey } from '@/i18n/i18n';

export const MAX_SEARCH_RESULTS = 15;

export const MIN_QUERY_LENGTH = 2;

export const MAX_RESULTS_PER_GROUP = 8;

export const NAV_GROUP_LABEL_KEY: TranslationKey = 'header.search.groups.navigation';

const ENTITY_TYPE_LABEL_KEYS: Record<string, TranslationKey | undefined> = {
  VesselComponent: 'header.search.groups.component',
  VesselJob: 'header.search.groups.job',
  VesselSpare: 'header.search.groups.spare'
};

export const getEntityTypeLabelKey = (entityType: string): TranslationKey | undefined =>
  ENTITY_TYPE_LABEL_KEYS[entityType];

const ROUTE_SEGMENT_TO_MODULE_CODE: Record<string, string | undefined> = {
  pms: 'PMS',
  pur: 'PUR',
  voy: 'VOY',
  quo: 'QUO',
  md: 'MD'
};

export const getModuleCodeFromSegment = (segment: string): string => ROUTE_SEGMENT_TO_MODULE_CODE[segment] ?? '';
